import {
  ALPHABET,
  ALPHABET_SET,
  compareTR,
  normalizeWord,
  toLowerTR,
} from "../turkish.js";
import type { EditionRules } from "./types.js";

export const TURKISH_EDITION: EditionRules = Object.freeze({
  id: "tr",
  locale: "tr-TR",
  timeZone: "Europe/Istanbul",
  productName: "Muhteşem Kelime+",
  shortName: "Kelime+",
  meaningSource: { name: "TDK Güncel Türkçe Sözlük", url: "https://sozluk.gov.tr/" },
  alphabet: ALPHABET,
  alphabetSet: ALPHABET_SET,
  keyboardRows: [
    ["E", "R", "T", "Y", "U", "I", "O", "P", "Ğ", "Ü"],
    ["A", "S", "D", "F", "G", "H", "J", "K", "L", "Ş", "İ"],
    ["BACKSPACE", "Z", "C", "V", "B", "N", "M", "Ö", "Ç", "ENTER"],
  ],
  normalizeWord,
  normalizeUsername: (input: string) => toLowerTR(input.trim()),
  isValidUsername: (input: string) => /^[A-Za-zÇĞİIÖŞÜçğıiöşü0-9_]{3,20}$/.test(input),
  compareWords: compareTR,
});
